<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main">
					<div class="mbxdh">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  
						  <el-breadcrumb-item :to="{ path: '/list_wenda'}">问询答复</el-breadcrumb-item>
						  
						  <el-breadcrumb-item>{{detail.name}}</el-breadcrumb-item>
						  
						</el-breadcrumb>
					</div>
					
					
					<div class="neirong_line">
						<div class="neirong_line_left">
							
							<div class="neirong_line_region">
								<div class="neirong_line_detail_title">
									{{detail.name}}
								</div>
								<!-- <div class="neirong_line_detail_content"> -->
									<!-- <iframe :src="detail.filePath" width="100%" height="900"></iframe> -->
									<!-- 这里处理成该企业的问答列表，根据点过来的企业现实其问答列表 -->
								<!-- </div> -->
								
								<div class="neirong_line_split"></div>
								
								<div class="neirong_line_region" v-for="(item, index) in list_record" :key="index">
									<div class="neirong_line_title" @click="toUrl('./detail_wenda?id=' + item.id)">
										<div class="neirong_line_title_icon"></div>
										{{item.nameFull.substr(0, 54)}}
									</div>
									<div class="neirong_line_split"></div>
								</div>
								
								
								
								<!-- <div class="neirong_line_split"></div> -->
								
								
							</div>
							
							<!-- <div class="neirong_line_page">
								这里后期可以关联其它跟本文相关的内容或链接
							</div> -->
						</div>
						
						
						<div class="neirong_line_right">
							<AdverRightCus></AdverRightCus>
						</div>
						
					</div>
					
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import AdverRightCus from '../components/adverRight.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			AdverRightCus,
		},
		data() {
			return {
				detail: {
					id: 0,
					com_id: 0,
					module_id: 0,
				},
				list_record: [],
			}
		},
		
		created() {
			this.detail.com_id = this.$route.query.id
			// this.detail.module_id = this.$route.query.moduleid
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			this.loadDetail()
			this.loadRecord()
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					// this.$router.push({path: url})
					let route_data = this.$router.resolve({path: url})
					window.open(route_data.href, '_blank')
				}
			},
			
			// 加载详情
			loadDetail() {
				let url = this.$common.apiUrl + 'pub_company_base/detail/' + this.detail.com_id
				// console.log(url)
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.detail = res.data.data
				})
			},
			
			// 加载列表
			loadRecord() {
				let url = this.$common.apiUrl + 'pub_company_ipofile/listWenda/' + this.detail.com_id
				// console.log(url)
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_record = res.data.data
				})
			},
			
			
			
			
		}
	}
</script>

<style scoped>
</style>